<template>
  <el-dialog title="选择产品批次"
             :visible.sync="visible"
             width="920px"
             append-to-body
             @closed="handleClosed">
    <el-row :gutter="16">
      <el-col :span="12">
        <el-input v-model="config.batchCode"
                  clearable=""
                  placeholder="请输入商品批次号"
                  style="margin-bottom: 10px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)">查询</el-button>
        </el-input>
        <el-table v-loading="loading"
                  max-height="720px"
                  border
                  :data="list">
          <el-table-column label="批次号"
                           min-width="120"
                           prop="batchCode"></el-table-column>
          <el-table-column label="库存"
                           width="80"
                           prop="inventory">
          </el-table-column>
          <el-table-column label="创建时间"
                           width="100">
            <template slot-scope="{row}">{{ row.createdTime | dateformat('YYYY-MM-DD')}}</template>
          </el-table-column>
          <el-table-column label="操作"
                           width="50">
            <template slot-scope="{ row }">
              <el-button type="text"
                         :disabled="!selectable(row) || row.inventory <= 0"
                         @click="addItem(row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       style="text-align: center;"
                       :current-page="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total"
                       @current-change="handleCurrentChange"></el-pagination>
      </el-col>
      <el-col :span="12">
        <div style="line-height: 32px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">已选择：</div>
        <el-table v-loading="loading"
                  max-height="720px"
                  border
                  :data="selection">
          <el-table-column label="批次号"
                           min-width="120"
                           prop="batchCode"></el-table-column>
          <el-table-column label="库存"
                           width="80"
                           prop="inventory">
          </el-table-column>
          <el-table-column label="订单数量"
                           width="100"
                           prop="goodsCount">
            <template slot-scope="{row}">
              <el-input-number style="width: 100%;"
                               :controls="false"
                               v-model="row.goodsCount"
                               :precision="0"
                               :max="row.inventory"
                               :min="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="50">
            <template slot-scope="{ $index}">
              <el-button type="text"
                         @click="deleteItem($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div slot="footer">
      <span style="font-size: 14px;margin-right: 8px;">合计订单数量：<span style="font-weight: bold;">{{ totalCount }}</span>件</span>
      <el-button :loading="loading"
                 @click="visible = false">关 闭</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'product-batch-select-modal',
  data () {
    return {
      loading: false,
      list: [],
      visible: false,
      config: { pageNum: 1, pageSize: 10, batchCode: '' },
      total: 0,
      selection: []
    }
  },
  computed: {
    totalCount ({ selection }) {
      const list = selection.map(i => i.goodsCount || 0)
      return list.reduce((prev, cur) => prev + cur, 0)
    }
  },
  methods: {
    selectable (row) {
      return !this.selection.map(i => i.batchId).includes(row.batchId)
    },
    addItem (row) {
      this.selection.push({ ...row, goodsCount: 0 })
    },
    deleteItem ($index) {
      this.selection.splice($index, 1)
    },
    handleClosed () {
      this.total = 0
      this.selection = []
      this.config = { ...this.$options.data().config }
    },
    handleCurrentChange (cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleSubmit () {
      const selection = this.selection
      if (selection.length === 0) {
        this.$message.error('请选择批次')
        return
      }
      if (selection.some(i => !i.goodsCount)) {
        this.$message.error('批次的订单数量不能为0')
        return
      }
      this.$emit('update', { batchList: this.selection.map(i => ({ ...i })), goodsCount: this.totalCount })
      this.visible = false
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('batch/getbatchs', {
        payload: { ...this.config },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => ({ ...i, inventory: i.goodsCount - (i.outGoodsCount || 0) - i.goodsDamageQty - i.toBeOutstockGoodsCount }))
        },
        fail: () => {
          this.loading = false
          this.list = []
        }
      })
    },
    fetch (options = {}, batchList) {
      this.selection = batchList.map(o => ({ ...o }))
      this.config = { ...this.config, ...options }
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
